import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CargoHeatingDownloadPopupComponent } from './cargo-heating-download-popup.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [CargoHeatingDownloadPopupComponent],
  imports: [CommonModule, MatIconModule],
  exports: [CargoHeatingDownloadPopupComponent]
})
export class CargoHeatingDownloadPopupModule {}
